import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UserData} from "../../models/user-data";
import {PagamentoDovuto, PagamentoMessage} from "../../models/pagamento";
import {MessageService} from "../../services/message.service";
import {TributoMessage} from "../../models/tributo";
import {DynamicFormRenderService} from "dmidynamic-form-render";
import {PagamentoService} from "../../services/istanza-pagamento.service";
import {IstanzaService} from "../../services/istanza.service";
import {IstanzaDTO} from "../../models/istanza";
import {TributiService} from "../../services/tributi.service";
import {AlertService} from "../../shared/alert/alert.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {zonedTimeToUtc} from "date-fns-tz";
import {parse} from "date-fns";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {Toolbar} from "../../models/toolbar";
import {FormBuilder, Validators} from "@angular/forms";
import {RatingService} from "../../services/rating.service";
import { PaymentnoticesService } from '../../services/paymentnotices.service';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-pagamento',
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.scss']
})
export class PagamentoComponent extends SubscriptionManager implements OnInit {
  @ViewChild("btnIndietro") buttonIndietro?: ElementRef
  @ViewChild('btnAvanti') buttonAvanti?: ElementRef
  curIndex: number;
  checkBoxPrivacy: boolean;
  userData: UserData;
  pagamentoMsg?: PagamentoMessage;
  tributoMsg?: TributoMessage;
  listaPagamenti?: Array<PagamentoDovuto>;
  isJsonForm: boolean;
  txtProcedi: string;
  mapStatiPagamento!: Map<string, { testo: string, colore: string }>;
  pagamentoSelezionato?: PagamentoDovuto;
  pagamentoSingolo: boolean;
  windowSize: number;
  cdServizio?: string;
  loading = false;
  selectedLanguage: string = this.translateService.currentLang;
  lastStep = false;
  selectedRating = 0;
  questionText = '';
  choices: string[] = [];
  inTextAreaPhase = false; // Aggiunto
  serviziToolbar: Toolbar[] = [];
  idServizio!: string;
  feedbackInviato = false;

  ratingForm = this.fb.group({
    valutazione: [this.fb.control<number | null>(null), Validators.required],
    primaRisposta: [this.fb.control<number | null>(null)],
    secondaRisposta: [this.fb.control<number | null>(null)],
    pnServizio: this.fb.group({
      id: ['', Validators.required]
    }),
    note: [''],
  })

  constructor(private ratingService: RatingService,private fb: FormBuilder,protected configurazioneService: ConfigurazioneGeneraleService,private paymentNoticesService: PaymentnoticesService, private router: Router, private activatedRoute: ActivatedRoute, private translateService: TranslateService, private alertService: AlertService, private tributiService: TributiService, private messageService: MessageService, private dynamicFormRenderService: DynamicFormRenderService, private pagamentoService: PagamentoService, private istanzaService: IstanzaService) {
    super();
    this.curIndex = 0;
    this.checkBoxPrivacy = false;
    this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}')
    this.isJsonForm = false;
    this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
    this.pagamentoSingolo = false;
    this.windowSize = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.windowSize = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.mapStatiPagamento = new Map([
      ["DA_PAGARE", {testo: "Da pagare", colore: "red"}],
      ["PAGAMENTO_AVVIATO", {testo: "Pagamento avviato", colore: "orange"}]
    ]);
    this.subs.sink = this.translateService.onLangChange.subscribe(() => {
      if (this.isJsonForm) {
        if (this.lastStep) {
          this.txtProcedi = this.translateService.instant('pagamenti.vaiLista');
        } else {
          if (this.curIndex !== 3) {
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
          } else {
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
          }
        }
      } else {
        if (this.lastStep) {
          this.txtProcedi = this.translateService.instant('pagamenti.vaiLista');
        } else {
          if (this.curIndex !== 1) {
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
          } else {
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
          }
        }
      }
    })
    console.warn(this.router.url);
    if (this.router.url.includes('/Servizi/Pagamento?servizio=') || this.activatedRoute.snapshot.params.idPagamento) {
      if (this.activatedRoute.snapshot.params.idPagamento) {
        this.pagamentoSingolo = true;
        this.subs.sink = this.pagamentoService.pagamento(this.activatedRoute.snapshot.params.idPagamento).subscribe({
          next: (pg?: PagamentoDovuto) => {
            if (pg === undefined) {
              this.setPagamentoJsonForm(JSON.parse(<string>localStorage.getItem('pagamentoJsonForm')))
              localStorage.setItem('pagamentoJsonForm', JSON.stringify(pg))
            } else {
              this.setPagamentoJsonForm(pg)
            }
          }
        })
      } else {
        this.subs.sink = this.activatedRoute.queryParamMap
          .subscribe(params => {
            this.loading = true;
            this.cdServizio = params.get('servizio') ? String(params.get('servizio')) : undefined;
            this.tributiService.tributi({cdServizio: params.get('servizio')}).subscribe((res) => {
              if(res.status !== 204){
                this.isJsonForm = true;
                this.tributoMsg = {tributo: res.body[0], nmTitolo: ''};
                localStorage.setItem('pagamentoJsonFormMultiplo', JSON.stringify(this.tributoMsg));
                this.setPagamentoJsonFormMultiplo();
              } else{
                this.loading = false;
                this.isJsonForm = true;
                this.alertService.creaAlert("Servizio non esistente", "danger", "sticky", 4000,true);
              }
            })
          })
        /*this.subs.sink = this.messageService.tributoMessage.subscribe((res?: TributoMessage) => {
          if (res === undefined) {
            this.tributoMsg = JSON.parse(<string>localStorage.getItem('pagamentoJsonFormMultiplo'));
          } else {
            this.tributoMsg = res;
            localStorage.setItem('pagamentoJsonFormMultiplo', JSON.stringify(res))
          }
          this.setPagamentoJsonFormMultiplo();
        }); */
      }
    } else {
      this.isJsonForm = false;
      this.subs.sink = this.messageService.pagamentoMessage.subscribe((res?: PagamentoMessage) => {
        if (res !== undefined) {
          this.pagamentoMsg = res;
          localStorage.setItem('pagamentoTributo', JSON.stringify(res))
        } else {
          this.pagamentoMsg = JSON.parse(<string>localStorage.getItem('pagamentoTributo'));
        }
      });
    }
    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
    this.subs.sink = this.ratingForm.controls['valutazione'].valueChanges.subscribe({
      next: () =>{
        this.ratingService.selectedChoiceIndex = -1;
        this.ratingForm.patchValue({
          primaRisposta: null,
          secondaRisposta: null,
        })
      }
    });
    this.serviziToolbar = JSON.parse(localStorage.getItem('servicesStorage') ?? '{}');
    for(const servizio of this.serviziToolbar){
      if(servizio.nmServizio === 'Pagamenti'){
        this.ratingForm.patchValue({
          pnServizio: {
            id: servizio.id,
          }
        })
        break;
      }
    }
  }

  tornaIndietro(): void {
    if (window.history.state.previousRoute) {
      void this.router.navigate([window.history.state.previousRoute])
    } else {
      void this.router.navigate(['/home']);
    }
  }

  //metodo che permette di passare allo step precedente
  goBack(): void {
    if (this.curIndex !== 0) {
      if (this.isJsonForm) {
        this.curIndex--;
        if (this.curIndex === 3) {
          this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
        } else {
          this.dynamicFormRenderService.abilitaFormDinamico();
          this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
        }
      } else {
        this.curIndex--;
        if (this.curIndex === 1) {
          this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
        } else {
          this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
        }
      }
    } else {
      if (window.history.state.previousRoute) {
        this.router.navigate([window.history.state.previousRoute])
      } else {
        this.router.navigate(['home'])
      }
    }
    this.buttonIndietro?.nativeElement.blur();
  }

  /**
   * Metodo che permette di passare allo step successivo
   */
  vaiAvanti(): void {
    if (this.isJsonForm) {
      if (this.curIndex === 1) {
        this.dynamicFormRenderService.importaValori(JSON.parse(this.b64DecodeUnicode(<string>this.pagamentoSelezionato?.jsonData)))
      }
      if (this.curIndex !== 4) {
        if (this.pagamentoSingolo) {
          if (this.curIndex === 1) {
            this.curIndex++;
            this.dynamicFormRenderService.disabilitaFormDinamico();
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
          } else if (this.curIndex === 2) {
            this.readBlob(JSON.stringify(this.dynamicFormRenderService.getJsonData())).then((blob) => {
              this.subs.sink = this.istanzaService.richiestaInizialeIstanza(this.inizializzaIstanza(blob).istanza).subscribe({
                next: (istanza) => {
                  istanza.jsonData = this.inizializzaIstanza(blob).jsonData;
                  this.subs.sink = this.istanzaService.richiestaSalvaIstanza(istanza).subscribe({})
                }
              })
            })
          } else {
            this.curIndex++;
            this.dynamicFormRenderService.abilitaFormDinamico();
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
          }
        } else {
          if (this.curIndex === 2) {
            this.curIndex++;
            this.dynamicFormRenderService.disabilitaFormDinamico();
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
          } else if (this.curIndex === 3) {
            this.readBlob(JSON.stringify(this.dynamicFormRenderService.getJsonData())).then((blob) => {
              this.loading = true;
              this.subs.sink = this.istanzaService.richiestaInizialeIstanza(this.inizializzaIstanza(blob).istanza).subscribe({
                next: (istanza) => {
                  this.loading = false;
                  istanza.jsonData = this.inizializzaIstanza(blob).jsonData;
                  this.subs.sink = this.istanzaService.richiestaSalvaIstanza(istanza).subscribe({
                      next: (res) => {
                        this.curIndex++;
                        this.loading = false;
                        this.lastStep = true;
                        this.txtProcedi = this.translateService.instant('pagamenti.vaiLista');
                      },
                      error: (err) => {
                        this.loading = false;
                        this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
                        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 3000, true)
                      }
                    }
                  )
                },
                error: (err) => {
                  this.loading = false;
                  this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
                  this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 3000, true)
                }
              })
            })
          } else {
            this.curIndex++;
            this.dynamicFormRenderService.abilitaFormDinamico();
            this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
          }
        }
      } else {
        this.router.navigate(['/Servizi/IstanzeEmesse'])
      }
    } else {
      if (this.curIndex !== 2) {
        this.curIndex++;
        if (this.curIndex === 1) {
          this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtPaga');
        } else {
          this.txtProcedi = this.translateService.instant('pagamenti.paginaPagamento.txtProcedi');
          if (this.curIndex === 2) {
            this.paga(this.pagamentoMsg);
            this.txtProcedi = this.translateService.instant('pagamenti.vaiLista');
          }
        }
      } else {
        this.router.navigate(['/Servizi/IstanzeEmesse'])
      }
    }
    this.buttonAvanti?.nativeElement.blur();
  }

  paga(rata: any): void {
    const requestBody = this.createUnipayBody(rata);
    this.loading = true;
    this.paymentNoticesService.getPagoPaRedirectUrl(requestBody).subscribe((res) => {
        this.loading = false;
        if (res.redirectUrl) {
          this.openNewTabOrNewWindow(res.redirectUrl);
        }
      },
      (err) => {
        this.loading = false;
        if (err.error.detail) {
          this.alertService.creaAlert("Tributo giá pagato o in fase di aggiornamento", "warning", "sticky", 5000, true)
        }
      })
  }

  openNewTabOrNewWindow(targetURL: string): void {
    const a = document.createElement('a');
    a.href = targetURL;

    a.target = '_blank'; // now it will open new tab/window and bypass any popup blocker!

    this.fireClickEvent(a);
  }

  fireClickEvent(element: HTMLAnchorElement): void {
    const evt = new window.MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });

    element.dispatchEvent(evt);
  }

  createUnipayBody(rata: any): any {
    console.warn(rata)
    const protocol = window.location.protocol;
    const host = window.location.host;
    const baseUrl = `${protocol}//${host}`;
    return {
      IUV: <string>rata.pagamento.iuv,
      causale: <string>rata?.pagamento.causale.descrizione,
      importoInCents: this.convertToCents(rata.pagamento.importo),
      email: <string>this.userData.email,
      returnCancelUrl: baseUrl+`/ca/Servizi/PagamentoTerminato/${rata?.pagamento.id.toString()}?cdTributo=${this.cdServizio}&status=Annullato`,
      returnOkUrl: baseUrl+`/ca/Servizi/PagamentoTerminato/${rata?.pagamento.id.toString()}?cdTributo=${this.cdServizio}&status=Terminato`,
      returnErrorUrl: baseUrl+`/ca/Servizi/PagamentoTerminato/${rata?.pagamento.id.toString()}?cdTributo=${this.cdServizio}&status=Errore`
    }
  }

  convertToCents(importo: number): string {
    const cents = importo * 100;
    const centesimiStringa = cents.toFixed(0);
    return centesimiStringa;
  }

  selezionaPagamento(pagamento: PagamentoDovuto): void {
    if (pagamento.stato !== 'PAGAMENTO_AVVIATO') {
      this.pagamentoSelezionato = pagamento;
    }
  }

  checkValidazioneStep(): boolean {
    if (this.curIndex === 0) {
      return !this.checkBoxPrivacy;
    } else if (this.isJsonForm && !this.pagamentoSelezionato) {
      return !this.pagamentoSingolo;
    } else {
      return false;
    }
  }

  b64DecodeUnicode(str: string): string {
    return decodeURIComponent(window.atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  inizializzaIstanza(base64: string): IstanzaDTO {
    return {
      istanza: {
        descrizione: this.pagamentoSelezionato?.descrizione ?? "",
        idDichiarante: <string>this.userData.idLogin,
        idRichiedente: <string>this.userData.idLogin,
        idPagamentoDovuto: this.pagamentoSelezionato?.idEsterno,
        servizio: {
          id: "",
          cdServizio: this.tributoMsg?.tributo.cdServizio ? this.tributoMsg.tributo.cdServizio : this.cdServizio
        },
        stato: {
          codice: "01"
        },
        tipoEsito: {
          id: ""
        }
      },
      jsonData: {
        contenuto: base64.split(',')[1]
      }
    }
  }

  setPagamentoJsonForm(pg: PagamentoDovuto): void {
    this.pagamentoSelezionato = pg;
    this.dynamicFormRenderService.clearFormControls();
    this.dynamicFormRenderService.importaFormDinamico(JSON.parse(this.b64DecodeUnicode(pg.servizio.jsonForm.contenuto)))
    this.dynamicFormRenderService.importaValori(JSON.parse(this.b64DecodeUnicode(pg.jsonData)))
    this.cdServizio = pg.servizio.cdServizio;
  }

  setPagamentoJsonFormMultiplo(): void {
    if (this.tributoMsg) {
      this.dynamicFormRenderService.clearFormControls();
      this.dynamicFormRenderService.importaFormDinamico(JSON.parse(this.b64DecodeUnicode(this.tributoMsg.tributo.jsonForm.contenuto)))
      if(this.userData.idLogin === undefined){
        this.userData = JSON.parse(localStorage.getItem('userData') ?? '{}')
      }
      if (this.userData.cf != null && this.tributoMsg.tributo.cdServizio) {
        this.loading = true;
        this.subs.sink = this.pagamentoService.pagamentiDovuti({
          cFDebitore: this.userData.cf,
          servizio: {cdServizio: this.tributoMsg.tributo.cdServizio}
        }).subscribe({
          next: (listaPagamenti) => {
            this.listaPagamenti = listaPagamenti;
          },
          error: (err) => {
            this.loading = false;
            this.alertService.creaAlert(err.error.messaggio, 'danger', 'sticky', 3000, true)
          },
          complete: () => {
            this.loading = false;
          }
        })
      }
    }
  }

  readBlob(blob: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onabort = reject;
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(new Blob([blob], {type: blob.type}));
    });
  }

  getCurrentDate(): Date {
    return new Date();
  }

  vaiAListaPagamenti(): void {
    this.router.navigate(['Servizi/IstanzeEmesse']).then();
  }

  integraPagamento(): void {
    this.loading = true;
    this.tributiService.integraPagamento(<number>this.pagamentoMsg?.integrazione.id, <number>this.pagamentoMsg?.pagamento?.id).subscribe({
      next: (res) => {
        this.lastStep = true;
      },
      error: () => {
        this.loading = false
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  formatDate(date: Date): Date {
    return zonedTimeToUtc(parse(date.toString(), "dd-MM-yyyy", new Date()), 'Europe/Rome');
  }

  onRatingSelected(rating: number): void {
    this.selectedRating = rating;
    this.ratingForm.get('valutazione')?.setValue(rating)
    if (this.selectedRating <= 3) {
      this.questionText = "Dove hai incontrato le maggiori difficoltà?";
      this.choices = ["A volte le indicazioni non erano chiare", "A volte le indicazioni non erano complete", "A volte non capivo se stavo procedendo correttamente", "Ho avuto problemi tecnici", "Altro"];
    } else {
      this.questionText = "Quali sono stati gli aspetti che hai preferito?";
      this.choices = ["Le indicazioni erano chiare", "Le indicazioni erano complete", "Capivo sempre che stavo procedendo correttamente", "Non ho avuto problemi tecnici", "Altro"];
    }
    this.inTextAreaPhase = false;
  }

  submitQuestion(): void {
    this.loading = true;
    this.subs.sink = this.ratingService.salvaFeedback(this.ratingForm.value).subscribe({
      error: (err) => {
        this.feedbackInviato = false;
        this.loading = false;
        this.alertService.creaAlert(err.error.messaggio, 'danger', "sticky", 5000, true);
      },
      complete: () => {
        this.feedbackInviato = true;
        this.loading = false;
        this.alertService.creaAlert('Feedback inviato con successo.', "success", "sticky", 5000, true);
      }
    });
  }

  showTextArea(): void {
    this.inTextAreaPhase = true; // Abilita la fase del campo di testo libero
  }

  backToChoices(): void {
    if (this.inTextAreaPhase) {
      this.inTextAreaPhase = false;
    }
  }

  resetSelection(): void {
    this.ratingService.resetArray(); // Resetta l'array delle stelle tramite il servizio
    this.ratingForm.get('valutazione')?.setValue(null)
    this.selectedRating = 0;
    this.questionText = '';
    this.choices = [];
  }

  handleChoiceSelected(selectedIndex: number): void {
    if(this.selectedRating < 4){
      this.ratingForm.patchValue({
        primaRisposta: null,
        secondaRisposta: selectedIndex,
      });
    }else{
      this.ratingForm.patchValue({
        primaRisposta: selectedIndex,
        secondaRisposta: null,
      })
    }
  }

}
